import type { IconSvgObject } from './types';

const AmpersandIcon: IconSvgObject = [
  ["path", { d: "M17 20C17 20 6.5 11 6.5 7C6.5 5.34315 7.84315 4 9.5 4C11.1569 4 12.5 5.34315 12.5 7C12.5 9 9.5 10 9.5 10C9.5 10 5 11.5 5 15.5C5 17.9853 7.01472 20 9.5 20C13.2504 20 15.9589 17.2217 16.7572 13.9805C17.0125 12.944 17.1401 12.4257 17.4118 12.2129C17.6834 12 18.1223 12 19 12", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default AmpersandIcon;
